export default __webpack_public_path__ + "media/images/memorialday/20_05_12_HPMemorialDay2020-2-1920600.jpg";